import * as React from "react";

import clsx from "clsx";

import * as PropTypes from "../prop-types";
import { PropsType } from "../PropsType";
import { spsGlobalPropTypes } from "../util";

export const propTypes = {
    ...spsGlobalPropTypes,
    ariaLabel: PropTypes.string
};

export type SpsTabbedNavProps = PropsType<typeof propTypes> & React.HTMLAttributes<HTMLDivElement>;

export function SpsTabbedNav(props: SpsTabbedNavProps) {
    const {
        children,
        className,
        "data-testid": testId,
        unsafelyReplaceClassName,
        ariaLabel,
        ...rest
    } = props;

    const classes = clsx(
        unsafelyReplaceClassName || "sps-tabbed-nav",
        className,
    );

    return (
        <div
            className={classes}
            role="group"
            aria-label={ariaLabel ? ariaLabel : "tabbed navigation with icons"}
            {...rest}
        >
            {children}
        </div>
    );
}

Object.assign(SpsTabbedNav, {
    propTypes,
    displayName: "SpsTabbedNav"
});